import AccessGroupCreateModal from './AccessGroupCreateModal';

export default AccessGroupCreateModal;
